import { axiosInstance } from "./";

const getNotifications = async (params) =>
  await axiosInstance.get(`/admin_portal_notifications`, { params });

const setNotificationSeen = async (id) =>
  await axiosInstance.patch(`/admin_portal_notifications/${id}`);

export { getNotifications, setNotificationSeen };